import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class LogService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getDriver(clientId: number, cardId: number): Observable<any> {
    let params = '?clientId=' + clientId + '&cardId=' + cardId;
    return this.http.get<any>(this.url + 'Movements/driver' + params);
  }

 saveConsumptionComments(log: any): Observable<any[]> {
    return this.http.post<any>(this.url + 'Log/ConsumptionComments', log);
  }

  saveLog(log: any): Observable<any[]> {
    return this.http.post<any>(this.url + 'Log/saveLog', log);
  }
}
